export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/InstantOfferPayment.66b752ab.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};